module.exports = __webpack_public_path__ + "static/media/logo8-grey.63f8785f.png";